import { isInStandaloneMode, logError } from 'src/utils/helpers'
import intlMessages from './translations'

export const getTag = (tag, intl) => {
  const tagsEnum = {
    renewal: intl.formatMessage(intlMessages.documentTagRenewal),
    policyChange: intl.formatMessage(intlMessages.documentTagPolicyChange),
    newBusiness: intl.formatMessage(intlMessages.documentTagNewBusiness),
    billingNotice: intl.formatMessage(intlMessages.documentTagBillingNotice),
    cancellation: intl.formatMessage(intlMessages.documentTagCancellation),
    rewrite: intl.formatMessage(intlMessages.documentTagRewrite),
    invoice: intl.formatMessage(intlMessages.documentTagInvoice),
    statement: intl.formatMessage(intlMessages.documentTagStatement),
    valid: intl.formatMessage(intlMessages.policyTagValid),
    cancelled: intl.formatMessage(intlMessages.policyTagCancelled),
    pending: intl.formatMessage(intlMessages.policyTagPending),
    expired: intl.formatMessage(intlMessages.policyTagExpired),
  }

  if (tagsEnum.hasOwnProperty(tag)) {
    return tagsEnum[tag].toLowerCase()
  }

  return tag
}

/**
 * Extracts "add to wallet" URL from Pink Slip document
 *
 * @param {object} pinkSlip
 * @return {string|null}
 */
export function getAddToWalletUrl(pinkSlip) {
  try {
    if (!(pinkSlip.hasOwnProperty('links') && Array.isArray(pinkSlip.links) === true)) {
      return null
    }

    // Get object containing wallet url
    const wallet = pinkSlip.links.find(link => link.rel === 'documents.wallet.download')

    if (wallet && wallet.url) {
      return wallet.url
    }

    return null
  } catch (e) {
    logError('Could not find wallet link', e, 0)
    return null
  }
}

export function openAddToWalletUrl(walletUrl) {
  try {
    if (!walletUrl) {
      return false
    }

    if (isInStandaloneMode()) {
      // Solve bug where "add to wallet" popup gets stuck when in standalone mode in iOS 13 and newer
      let windowOpenReference = window.open()
      windowOpenReference.location = walletUrl
    } else {
      window.open(walletUrl, '_blank')
    }
  } catch (e) {
    logError('Open add to wallet URL', e)
  }
}
